/* eslint-disable */
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  fetch_all_actions,
  fetch_transition_types,
  create_action,
  create_workflow_status_approval_rule,
  create_workflow_status_transition_rule,
  delete_workflow_status_approval_rule,
  delete_action,
  delete_transition_rule,
  fetch_section_access,
  assign_section_access,
  fetch_users_by_role,
  update_transition_rule,
  update_action,
  fetch_form_workflow_transition_rules,
  fetch_status_reviewers,
  assign_status_reviewers,
  fetch_user_roles,
  fetch_selected_workflow,
  fetch_entity_type_workflow_forms,
  assign_entity_type_workflow_status,
  unassign_entity_type_workflow_status,
  assign_entity_type_workflow_form,
  unassign_entity_type_workflow_form,
  fetch_assign_form_status_data,
  assign_form_status,
  unassign_form_status,
  unassign_section_access,
  unassign_status_reviewers,
} from '@/services/workflow_service';
import { fetch_form_statuses } from '@/services/form_metadata_service';
import { fetch_form_structure, fetch_main_sections_by_form } from '@/services/main_section_service';

import ReviewersTab from './components/ReviewersTab.vue';
import SectionAccessTab from './components/SectionAccessTab.vue';
import PreviewTab from './components/PreviewTab.vue';
import ActionsTab from './components/ActionsTab.vue';
import configure_workflow_computed from './configure_workflow_computed';
import {
  as_array,
  as_object,
  collapsed_condition_rule,
  editable_condition_rule,
  flatten_error_strings,
  is_safe_object_key,
  new_form_status_ids,
  normalize_assigned_statuses,
  object_entries,
  object_values,
  safe_get_key,
  safe_keyed_array,
  safe_set,
  section_access_entry_values,
  status_id_set,
  transition_condition_action_label,
  transition_condition_payload_rule,
} from './configure_workflow_helpers';

function flatten_transition_condition_node(node, inherited_operator = 'AND') {
  if (!node?.rules?.length || !node.operator) {
    return [{ ...as_object(node), connector_operator: inherited_operator }];
  }

  return as_array(node.rules).flatMap((child, index) =>
    flatten_transition_condition_node(child, index === 0 ? inherited_operator : String(node.operator || 'AND'))
  );
}

function first_truthy_value(values, fallback = '') {
  return values.find(Boolean) || fallback;
}

function normalize_boolean_flag(value, fallback = false) {
  if (value === true || value === false) return value;
  if (value === 1 || value === '1') return true;
  if (value === 0 || value === '0') return false;
  const normalized = String(value ?? '').trim().toLowerCase();
  if (['true', 'yes', 'active'].includes(normalized)) return true;
  if (['false', 'no', 'inactive'].includes(normalized)) return false;
  return fallback;
}

function normalize_assigned_form_status(status, index) {
  return {
    id: Number(first_truthy_value([status?.id, status?.assigned_form_status_id], 0)),
    status_id: Number(first_truthy_value([status?.status_id, status?.workflow_status_id, status?.id], 0)),
    status_name: String(first_truthy_value(
      [status?.status_name, status?.workflow_status_name, status?.status, status?.name],
      `Status ${index + 1}`
    )).trim(),
    order: Number(first_truthy_value([status?.order, status?.order_number], index + 1)),
    is_initial: Boolean(status?.is_initial),
    is_final: Boolean(status?.is_final),
  };
}

function create_transition_builder() {
  return {
    movement: {
      form_id: '',
      from_status_id: '',
      to_status_id: '',
      is_active: false,
    },
    trigger: {
      action_id: '',
      transition_type_id: '',
    },
    conditions: {
      mode: 'none',
      operator: 'AND',
      rules: [],
    },
  };
}

export default {
  name: 'ConfigureWorkflow',
  mixins: [alert_mixin],
  components: {
    ReviewersTab,
    SectionAccessTab,
    PreviewTab,
    ActionsTab
  },
  data: () => ({
    statuses_loading: false,
    statuses_saving: false,
    transitions_loading: false,
    transitions_saving: false,
    forms_loading: false,
    reviewers_loading: false,
    reviewers_saving: false,
    selected_assignable_form_ids: [],
    show_form_dropdown: false,
    assign_form_dropdown_open: false,
    transition_mode: 'list',
    transition_builder_step: 1,
    editing_transition_id: null,
    transition_builder: create_transition_builder(),
    approval_rules_saving: false,
    section_access_loading: false,
    section_access_saving: false,
    actions_loading: false,
    action_saving: false,
    action_delete_running_id: null,
    role_users_loading: false,
    reviewer_user_query: '',
    reviewer_roles_loading: false,
    selected_status_id: '',
    selected_source: '',
    selected_target: '',
    selected_form_id: '',
    selected_assignable_form_id: '',
    selected_form_status_ids: [],
    dragged_form_status_id: '',
    selected_assignable_status_ids: [],
    assignable_status_query: '',
    assign_status_dropdown_open: false,
    active_transition_multiselect_key: '',
    reviewer_role_query: '',
    reviewer_count_required: 1,
    action_trigger: '',
    min_approvals_required: 1,
    active_workflow_tab: 'forms',
    selected_transition_type_id: '',
    modal_status_rows: [],
    view_mode: 'grid',
    all_statuses: [],
    assigned_status_configs: [],
    assigned_form_statuses: [],
    transitions: [],
    available_forms: [],
    available_forms_loading: false,
    form_assignment_by_form_id: {},
    form_toggle_loading_by_form_id: {},
    workflow_forms: [],
    transition_types: [],
    status_reviewers: null,
    reviewer_role_options: [],
    role_user_options: [],
    available_users: [],
    selected_reviewer_user_ids: [],
    selected_reviewer_role_ids: [],
    reviewer_assign_mode: 'role',
    selected_reviewer_role_option_id: '',
    selected_reviewer_user_role_filter_id: '',
    selected_reviewer_user_option_id: '',
    selected_context_transition_id: '',
    approval_mode: 'parallel',
    initial_route_tab_applied: false,
    approval_rule_order_by_reviewer_user_id: {},
    form_sections: [],
    workflow_actions: [],
    section_access_map: {},
    section_access_matrix: {},
    section_access_bulk_action_ids: [],
    selected_section_access_role_key: '',
    selected_section_access_user_key: '',
    duplicate_action_warning: '',
    action_form: {
      action_id: null,
      action_name: '',
      description: '',
    },
    action_edit_form: {
      action_id: null,
      action_name: '',
      description: '',
    },
  }),
  created() {
    this.load_workflow_configuration();
  },
  mounted() {
    document.addEventListener('click', this.handle_assign_status_dropdown_outside_click);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handle_assign_status_dropdown_outside_click);
  },
  computed: configure_workflow_computed,
  watch: {
    async selected_form_id() {
      this.load_status_library_data();
      this.load_form_statuses_and_transitions();
      this.load_section_access_dependencies();
      if (this.active_workflow_tab === 'section_access') {
        await this.prepare_section_access_tab();
      }
    },

    async selected_status_id() {
      await this.load_status_reviewers();
      this.load_section_access_dependencies();
      if (this.active_workflow_tab === 'section_access') {
        await this.prepare_section_access_tab();
      }
      this.redirect_from_disabled_workflow_tab();
    },
    async active_workflow_tab(tab_id) {
      if (tab_id === 'actions') {
        this.load_workflow_actions();
      }
      if (tab_id === 'section_access') {
        await this.prepare_section_access_tab();
      }
    },
    selected_section_access_role_key(val) {
      if (!val) return;
      this.load_section_access();
    },
    selected_section_access_user_key() {
      this.load_section_access();
    },
  },

  methods: {
    handleOutsideClick(event) {
    if (
      this.$refs.assignFormMultiselect &&
      !this.$refs.assignFormMultiselect.contains(event.target)
    ) {
      this.assign_form_dropdown_open = false;
    }
  },
    workflow_status_name_is_terminal(name = '') {
      const value = String(name || '').trim().toLowerCase();
      return ['approved', 'rejected', 'declined', 'closed', 'completed', 'complete', 'cancelled', 'canceled', 'done']
        .some((word) => value.includes(word));
        
    },

    is_automatic_transition_record(transition = {}) {
      const transition_type = String(transition.transitionType || transition.type || '').trim().toLowerCase();
      return transition_type === 'automatic' || transition_type.includes('automatic');
    },

    has_section_access_matrix_values() {
      return object_values(this.section_access_matrix)
        .some((action_ids) => Array.isArray(action_ids) && action_ids.length > 0);
    },

    transition_reviewers_configured() {
      return this.assigned_reviewers.length > 0;
    },

    transition_section_access_configured() {
      return this.has_section_access_matrix_values();
    },

    select_transition_context(transition = {}) {
      this.selected_context_transition_id = String(transition.id || '');
      const source_status = this.transition_form_statuses.find(
        (status) => Number(status.assignedFormStatusId || 0) === Number(transition.sourceId || 0)
      );
      if (source_status?.workflowStatusId) {
        this.select_status(source_status.workflowStatusId);
      }
    },

    select_first_section_access_assignment() {
      if (this.selected_section_access_assignment_key) return;
      const first_assignment = this.section_access_assignment_options[0];
      if (first_assignment?.key) {
        this.set_selected_section_access_assignment_key(first_assignment.key);
      }
    },

    async prepare_section_access_tab() {
      if (!this.selected_form_id || !this.selected_status_id) return;

      await this.load_status_reviewers();
      await this.load_section_access_dependencies();

      if (
        this.selected_section_access_assignment_key
        && !this.section_access_assignment_options.some((option) => option.key === this.selected_section_access_assignment_key)
      ) {
        this.set_selected_section_access_assignment_key('');
      }

      this.select_first_section_access_assignment();

      if (this.selected_section_access_assignment_key) {
        await this.load_section_access();
      }
    },

    normalize_transition_question(question = {}, index = 0) {
      const normalized_question = {
        id: Number(question?.question_id ?? question?.id ?? 0)
          || `${Date.now()}-${index}`,

        label: String(
          question?.label
          ?? question?.question
          ?? question?.question_text
          ?? `Question ${index + 1}`
        ).trim(),
      };
      return normalized_question;
    },

    normalize_transition_sub_section(sub_section = {}, index = 0) {
        const raw_questions = Array.isArray(sub_section?.questions)
          ? sub_section.questions
          : (Array.isArray(sub_section?.section_questions) ? sub_section.section_questions : []);
        const questions = raw_questions.map((question, question_index) =>
              this.normalize_transition_question(question, question_index)
            );

        return {
          id: Number(
            sub_section?.section_id
            ?? sub_section?.section?.id
            ?? sub_section?.section
            ?? sub_section?.id
            ?? sub_section?.form_section_id
            ?? 0
          ),
          form_section_id: Number(sub_section?.id ?? sub_section?.form_section_id ?? 0),
          section_id: Number(
            sub_section?.section_id
            ?? sub_section?.section?.id
            ?? sub_section?.section
            ?? sub_section?.id
            ?? 0
          ),
          section_name: String(
            sub_section?.section_name
            ?? sub_section?.name
            ?? sub_section?.title
            ?? `Sub Section ${index + 1}`
        ).trim(),
        description: String(
          sub_section?.description
          ?? sub_section?.name
          ?? sub_section?.subtitle
          ?? ''
        ).trim(),
        order_number: Number(sub_section?.order_number ?? index + 1),
        questions,
      };
    },

    normalize_transition_main_section(main_section = {}, index = 0) {
        const raw_sub_sections = Array.isArray(main_section?.sub_sections)
          ? main_section.sub_sections
          : (Array.isArray(main_section?.sections)
            ? main_section.sections
            : (Array.isArray(main_section?.form_sections) ? main_section.form_sections : []));
        const sub_sections = raw_sub_sections.map((sub_section, sub_index) =>
              this.normalize_transition_sub_section(sub_section, sub_index)
            );

        return {
          id: Number(main_section?.main_section_id ?? main_section?.main_section ?? main_section?.id ?? 0),
          main_section_id: Number(main_section?.main_section_id ?? main_section?.main_section ?? main_section?.id ?? 0),
          section_id: Number(
            main_section?.section_id
            ?? main_section?.section?.id
            ?? main_section?.section?.section_id
            ?? 0
          ),
          form_section_id: Number(
            main_section?.form_section_id
            ?? main_section?.form_section?.id
            ?? main_section?.id
            ?? 0
          ),
          main_section_name: String(
            main_section?.main_section_name
            ?? main_section?.name
            ?? main_section?.main_section?.name
            ?? `Main Section ${index + 1}`
        ).trim(),
        description: String(
          main_section?.description
          ?? main_section?.name
          ?? main_section?.main_section?.description
          ?? ''
        ).trim(),
        order_number: Number(main_section?.order_number ?? index + 1),
        sub_sections,
      };
    },

    normalize_status(status = {}, index = 0) {
      const name = String(status?.status || status?.name || `Status ${index + 1}`).trim();
      return {
        id: String(status?.id ?? index),
        name,
        description: '',
        badge: 'Process State'
      };
    },

    normalize_workflow_form(form = {}, index = 0) {
      return {
        id: Number(form.form_id || form.id || 0),
        name: String(form.form_name || form.name || `Form ${index + 1}`).trim(),
        isAssigned: Boolean(form.is_assigned),
        assignmentId: Number(form.entity_workflow_form_id || form.assignment_id || 0) || null,
      };
    },

    normalize_transition_type(item = {}) {
      return {
        id: Number(item.id || 0),
        name: String(item.name || item.transition_type || '').trim()
      };
    },

    normalize_reviewer_role(role = {}) {
      return {
        id: Number(role.id || 0),
        name: String(role.role_name || role.role || role.name || '').trim()
      };
    },

    normalize_reviewer_payload(data = {}) {
      const source = Array.isArray(data) ? (data[0] || {}) : data;
      return {
        id: source.id,
        users: Array.isArray(source.users) ? source.users : [],
        roles: Array.isArray(source.roles) ? source.roles : [],
        approval_rules: Array.isArray(source.approval_rules) ? source.approval_rules : [],
        required_reviewer_count: source.required_reviewer_count || 1
      };
    },

    build_workflow_form_payload(workflow_id = null) {
      const normalized_workflow_id = Number(workflow_id || this.workflow_id || 0);
      const payload = {
        entity_workflow_id: normalized_workflow_id,
        entity_type_workflow_id: normalized_workflow_id,
        workflow_id: normalized_workflow_id,
      };

      if (this.route_project_id) {
        payload.project_id = Number(this.route_project_id);
      }

      const workflow_payload = { ...payload };
      return workflow_payload;
    },

    async load_status_library_data(workflowAvailableStatuses = []) {
      try {
        const [statusLibrary, statusData] = await Promise.all([
          fetch_form_statuses(),
          this.selected_form_id
            ? fetch_assign_form_status_data({ form_id: Number(this.selected_form_id || 0) })
            : Promise.resolve(null),
        ]);

        const form_available_statuses = statusData?.available_statuses
          || statusData?.data?.available_statuses
          || [];
        const combined_status_source = Array.isArray(statusLibrary) && statusLibrary.length
          ? statusLibrary
          : (Array.isArray(workflowAvailableStatuses) && workflowAvailableStatuses.length
            ? workflowAvailableStatuses
            : form_available_statuses);

        this.all_statuses = (Array.isArray(combined_status_source) ? combined_status_source : [])
          .map((status, index) => this.normalize_status(status, index));
        this.assigned_form_statuses = this.normalize_assigned_form_statuses(
          statusData?.assigned_statuses
          || statusData?.data?.assigned_statuses
          || statusData?.selected_statuses
          || statusData?.data?.selected_statuses
          || []
        );
        this.selected_form_status_ids = this.ordered_form_status_ids_for_boundaries(this.assigned_form_statuses);
        this.sync_existing_form_statuses_into_workflow();
      } catch (error) {
        this.error('[ConfigureWorkflow] load_status_library_data failed', error);
        this.all_statuses = [];
        this.assigned_form_statuses = [];
        this.selected_form_status_ids = [];
      }
    },

    async load_selected_form_status_data() {
      if (!this.selected_form_id) return;

      const statusData = await fetch_assign_form_status_data({ form_id: Number(this.selected_form_id || 0) });
      this.assigned_form_statuses = this.normalize_assigned_form_statuses(
        statusData?.assigned_statuses
        || statusData?.data?.assigned_statuses
        || statusData?.selected_statuses
        || statusData?.data?.selected_statuses
        || []
      );
      this.selected_form_status_ids = this.ordered_form_status_ids_for_boundaries(this.assigned_form_statuses);
      this.sync_existing_form_statuses_into_workflow();
      this.initialize_status_selections();
    },

    sync_existing_form_statuses_into_workflow() {
      const existing_status_ids = new Set(this.all_statuses.map((status) => String(status.id)));
      const assigned_workflow_status_ids = new Set(
        this.assigned_status_configs.map((assignment) => String(assignment.status_id || ''))
      );

      this.assigned_form_statuses.forEach((status, index) => {
        const status_id = String(status.status_id || '');
        if (!status_id) return;

        if (!existing_status_ids.has(status_id)) {
          this.all_statuses = [
            ...this.all_statuses,
            this.normalize_status({
              id: status.status_id,
              name: status.status_name,
              status: status.status_name,
            }, this.all_statuses.length),
          ];
          existing_status_ids.add(status_id);
        }

        if (!assigned_workflow_status_ids.has(status_id)) {
          this.assigned_status_configs = [
            ...this.assigned_status_configs,
            {
              id: Number(status.id || `9${Date.now()}${index}`),
              status_id: Number(status.status_id),
              order: Number(status.order || index + 1),
              transition_action: String(status.status_name || '').trim() || 'Submit',
              is_initial: Boolean(status.is_initial),
              is_final: Boolean(status.is_final),
            },
          ];
          assigned_workflow_status_ids.add(status_id);
        }
      });
    },

    async load_form_statuses_and_transitions() {
      if (!this.selected_form_id) return;
      this.transitions_loading = true;
      try {
        await this.load_selected_form_status_data();
        await this.load_transition_rules();
      } catch {
        this.show_error('Failed to load transitions.');
      } finally {
        this.transitions_loading = false;
      }
    },

    normalize_assigned_form_statuses(records = []) {
      const seen_status_ids = new Set();
      return (Array.isArray(records) ? records : [])
        .map(normalize_assigned_form_status)
        .filter((status) => {
          const status_id = String(status.status_id || '');
          if (!status_id || seen_status_ids.has(status_id)) return false;
          seen_status_ids.add(status_id);
          return true;
        });
    },

    ordered_form_status_ids_for_boundaries(statuses = []) {
      const records = Array.isArray(statuses) ? statuses : [];
      const workflow_order_by_status_id = new Map(
        (this.assigned_status_configs || []).map((assignment) => [
          String(assignment.status_id || ''),
          Number(assignment.order || 0),
        ])
      );
      const sorted_records = [...records].sort((left, right) => {
        const left_order = workflow_order_by_status_id.get(String(left?.status_id || '')) || Number(left?.order || 0) || 0;
        const right_order = workflow_order_by_status_id.get(String(right?.status_id || '')) || Number(right?.order || 0) || 0;
        return left_order - right_order;
      });
      const initial = sorted_records.find((status) => status.is_initial);
      const middle = sorted_records.filter((status) =>
        String(status.status_id) !== String(initial?.status_id || '')
      );

      return [initial, ...middle]
        .filter(Boolean)
          .map((status) => String(status.status_id))
          .filter(Boolean);
    },

    build_workflow_status_order_payload(ordered_status_ids = []) {
      const order_ids = Array.isArray(ordered_status_ids) ? ordered_status_ids.map(String) : [];
      const status_by_id = new Map(
        (this.assigned_statuses || []).map((status) => [String(status.id), status])
      );

      return order_ids
        .map((status_id, index) => {
          const status = status_by_id.get(String(status_id));
          if (!status) return null;

          return {
            status_id: Number(status.id),
            order: index + 1,
            workflow_id: Number(this.workflow_id),
            transition_action: String(status.transitionAction || status.transition_action || status.name || 'Submit').trim() || 'Submit',
          };
        })
        .filter(Boolean);
    },

    apply_workflow_status_order_locally(ordered_status_ids = []) {
      const next_order_by_status_id = new Map(
        (Array.isArray(ordered_status_ids) ? ordered_status_ids : []).map((status_id, index) => [
          String(status_id),
          index + 1,
        ])
      );

      this.assigned_status_configs = (this.assigned_status_configs || [])
        .map((assignment) => ({
          ...assignment,
          order: next_order_by_status_id.get(String(assignment.status_id || '')) || Number(assignment.order || 0),
        }))
        .sort((left, right) => Number(left.order || 0) - Number(right.order || 0));
    },

    apply_form_status_selection_locally(orderedSelected = [], response = null) {
      const response_statuses = response?.data?.assigned_statuses
        || response?.assigned_statuses
        || [];

      if (Array.isArray(response_statuses) && response_statuses.length) {
        this.assigned_form_statuses = this.normalize_assigned_form_statuses(response_statuses);
        this.selected_form_status_ids = this.ordered_form_status_ids_for_boundaries(this.assigned_form_statuses);
        return;
      }

      const current_by_status_id = new Map(
        this.assigned_form_statuses.map((status) => [String(status.status_id), status])
      );

      this.assigned_form_statuses = orderedSelected.map((status, index) => {
        const current = current_by_status_id.get(String(status.id)) || {};
        return {
          id: Number(current.id || 0),
          status_id: Number(status.id),
          status_name: String(status.name || status.status_name || '').trim(),
          order: index + 1,
          is_initial: current.is_initial != null ? Boolean(current.is_initial) : index === 0,
          is_final: current.is_final != null ? Boolean(current.is_final) : false,
        };
      });
      this.selected_form_status_ids = orderedSelected.map((status) => String(status.id));
    },

    async load_transition_rules() {
      if (!this.selected_form_id) return;
      try {
        // Fetch rules for all assigned statuses
        const rulesByKey = new Map();
        const requests = this.transition_form_statuses.map(status => 
          fetch_form_workflow_transition_rules({
            form_id: Number(this.selected_form_id),
            from_status_id: Number(status.assignedFormStatusId)
          })
        );
        
        const results = await Promise.allSettled(requests);
        results.forEach(result => {
          if (result.status === 'fulfilled') {
            const rules = result.value?.data || [];
            rules.forEach(rule => {
              const record = this.normalize_transition_record(rule);
              rulesByKey.set(String(record.id), record);
            });
          }
        });
        this.transitions = Array.from(rulesByKey.values());
      } catch (error) {
        this.error('Load transition rules error:', error);
      }
    },

    normalize_transition_record(rule) {
      const from_status_id = Number(rule.from_status_id || rule.from_status?.id || 0);
      const to_status_id = Number(rule.to_status_id || rule.to_status?.id || 0);
      const transition_type_id = Number(rule.transition_type_id || rule.transition_type?.id || 0);
      const from_status = this.transition_form_statuses.find(s => Number(s.assignedFormStatusId) === from_status_id);
      const to_status = this.transition_form_statuses.find(s => Number(s.assignedFormStatusId) === to_status_id);
      const transition_type = this.transition_types.find(t => Number(t.id) === transition_type_id);
      
      const condition = rule.condition || {};
      const first_rule = (condition.rules || [])[0] || {};
      const action_name = rule.action || condition.action || first_rule.action || 'Transition';
      
      return {
        id: rule.id,
        ruleId: rule.id,
        sourceId: from_status_id,
        targetId: to_status_id,
        source: from_status?.name || rule.from_status?.status_name || 'Unknown',
        target: to_status?.name || rule.to_status?.status_name || 'Unknown',
        sourceIcon: 'bi bi-arrow-up-circle',
        targetIcon: 'bi bi-bullseye',
        targetIconClass: 'workflow-transition-target-primary-icon',
        targetLabelClass: 'workflow-transition-target-primary-label',
        action: action_name,
        actionTrigger: action_name,
        actionTriggerId: rule.transition_trigger_id || first_rule.action_id,
        transitionType: transition_type?.name || rule.transition_type?.name || 'Manual',
        transitionTypeId: transition_type_id,
        minApprovals: Number(rule.min_approvals || first_rule.approvals_required || 1),
        conditionsSummary: this.build_conditions_summary(condition),
        humanSummary: this.build_transition_preview_sentence({
          source: from_status?.name || rule.from_status?.status_name || 'Unknown',
          target: to_status?.name || rule.to_status?.status_name || 'Unknown',
          action: action_name,
          transitionType: transition_type?.name || rule.transition_type?.name || 'Manual',
          condition,
        }),
        isActive: normalize_boolean_flag(rule.is_active, false),
        fullRule: rule
      };
    },

    build_transition_preview_sentence({ source, target, action, transitionType, condition }) {
      const transition_type_name = String(transitionType || '').trim().toLowerCase();
      const conditions_summary = this.build_conditions_summary(condition);
      if (transition_type_name === 'automatic' || transition_type_name.includes('automatic')) {
        return conditions_summary && conditions_summary !== 'No conditions'
          ? `Automatically move ${source} -> ${target} when ${conditions_summary}.`
          : `Automatically move ${source} -> ${target} when conditions are met.`;
      }

      return `When user clicks "${action || 'Trigger'}", move ${source} -> ${target}.`;
    },

    build_conditions_summary(condition) {
      if (!condition?.rules?.length) return 'No conditions';
      return this.flatten_transition_condition_rules(condition)
        .map((rule) => this.transition_condition_summary(rule))
        .filter(Boolean)
        .join(' • ');
    },

    flatten_transition_condition_rules(condition) {
      return as_array(condition?.rules).flatMap((rule) =>
        flatten_transition_condition_node(rule, String(condition?.operator || 'AND'))
      );
    },

    transition_condition_summary(rule = {}) {
      const condition_type = String(rule.condition_type || rule.action_type || '').trim();
      const selected_actions = Array.isArray(rule.selected_actions)
        ? rule.selected_actions
        : (Array.isArray(rule.required_action_ids) ? rule.required_action_ids : []);
      const selected_sections = Array.isArray(rule.selected_sections) ? rule.selected_sections : [];
      const selected_questions = Array.isArray(rule.selected_questions) ? rule.selected_questions : [];
      const role_required = String(rule.required_role || rule.role_required || '').trim();
      const completion_type = String(rule.completion_type || rule.required_state || '').trim();
      const approvals_required = Number(rule.approvals_required || 0);

      if (condition_type === 'reviewer_approval') {
        const role_name = this.transition_role_options.find((role) => String(role.id) === role_required)?.name || 'selected role';
        return `${approvals_required || 1} ${role_name} approval${approvals_required === 1 ? '' : 's'} required`;
      }

      if (condition_type === 'section_action') {
        const action_names = selected_actions
          .map((action_id) => this.workflow_actions.find((action) => String(action.id) === String(action_id))?.name)
          .filter(Boolean);

        return action_names.length
          ? `Required actions: ${this.format_transition_name_list(action_names, 'actions')}`
          : 'Required actions';
      }

      if (condition_type === 'status_check' || condition_type === 'previous_status_reached') {
        const status_names = this.selected_transition_status_labels(rule);
        const readable_state = (completion_type || 'reached').replace(/_/g, ' ');
        return status_names.length
          ? `${this.format_transition_name_list(status_names, 'statuses')} was previously ${readable_state}`
          : `Previous status was previously ${readable_state}`;
      }

      const summary_parts = [];
      if (completion_type) summary_parts.push(`${completion_type} questions`);
      if (selected_questions.length) summary_parts.push(`${selected_questions.length} required question${selected_questions.length === 1 ? '' : 's'}`);
      if (selected_sections.length) {
        const section_labels = this.selected_transition_section_labels(rule);
        summary_parts.push(`Sections: ${this.format_transition_name_list(section_labels, 'sections')}`);
      }
      const question_labels = this.selected_transition_question_labels(rule);
      if (question_labels.length) {
        summary_parts.push(`Questions: ${this.format_transition_name_list(question_labels, 'questions')}`);
      }

      return summary_parts.join(', ') || 'Question completion required';
    },

    format_transition_name_list(values = [], fallback_plural = 'items') {
      const names = (Array.isArray(values) ? values : [])
        .map((value) => String(value || '').trim())
        .filter(Boolean);

      if (!names.length) {
        return `Selected ${fallback_plural}`;
      }

      if (names.length <= 2) {
        return names.join(', ');
      }

      return `${names.slice(0, 2).join(', ')} +${names.length - 2} more`;
    },

    create_empty_transition_condition_rule() {
      return {
        id: `condition-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        condition_type: 'question_completion',
        action_id: '',
        required_action_ids: [],
        action_type: 'question_completion',
        action: '',
        required_state: 'complete',
        section_scope: 'all',
        question_scope: 'all',
        role_required: '',
        approvals_required: 1,
        selected_statuses: [],
        selected_sections: [],
        selected_sections_for_questions: [],
        selected_questions: [],
        connector_operator: 'AND',
        collapsed: false,
      };
    },

    ensure_transition_condition_rules() {
      if (!Array.isArray(this.transition_builder.conditions.rules)) {
        this.transition_builder.conditions.rules = [];
      }
      if (!this.transition_builder.conditions.rules.length) {
        this.transition_builder.conditions.rules = [this.create_empty_transition_condition_rule()];
      }
    },

    set_transition_condition_mode(mode) {
      if (this.is_automatic_transition_type && mode !== 'advanced') {
        mode = 'advanced';
      }
      this.transition_builder.conditions.mode = mode;
      if (mode === 'advanced') {
        this.ensure_transition_condition_rules();
      }
    },

    add_transition_condition_rule() {
      this.ensure_transition_condition_rules();
      const rules = this.transition_builder.conditions.rules;
      const last_rule = rules[rules.length - 1];
      if (last_rule && !last_rule.connector_operator) {
        last_rule.connector_operator = 'AND';
      }
      this.transition_builder.conditions.rules = [
        ...rules,
        this.create_empty_transition_condition_rule(),
      ];
    },

    remove_transition_condition_rule(index) {
      const next_rules = this.transition_condition_rules.filter((_, rule_index) => rule_index !== index);
      this.transition_builder.conditions.rules = next_rules.length
        ? next_rules
        : [this.create_empty_transition_condition_rule()];
    },

    toggle_transition_condition_rule(index) {
      const rule = this.transition_condition_rules[index];
      if (!rule) return;
      rule.collapsed = !rule.collapsed;
    },

    normalize_transition_condition_rule(rule) {
      if (!rule) return;
      if (!Array.isArray(rule.required_action_ids)) rule.required_action_ids = [];
      if (!Array.isArray(rule.selected_statuses)) rule.selected_statuses = [];
      if (!Array.isArray(rule.selected_sections)) rule.selected_sections = [];
      if (!Array.isArray(rule.selected_sections_for_questions)) rule.selected_sections_for_questions = [];
      if (!Array.isArray(rule.selected_questions)) rule.selected_questions = [];
      if (!rule.connector_operator) rule.connector_operator = this.transition_builder?.conditions?.operator || 'AND';
      if (!rule.condition_type) rule.condition_type = 'question_completion';
      if (!rule.section_scope) rule.section_scope = 'all';
      if (!rule.question_scope) rule.question_scope = 'all';
      if (!rule.required_state) rule.required_state = 'complete';
      if (!rule.role_required) rule.role_required = '';
      if (!rule.approvals_required) rule.approvals_required = 1;
    },

    on_transition_condition_type_change(rule) {
      this.normalize_transition_condition_rule(rule);
      rule.action_type = rule.condition_type;
      rule.collapsed = false;

      if (rule.condition_type !== 'section_action') {
        rule.required_action_ids = [];
      }

      if (rule.condition_type !== 'reviewer_approval') {
        rule.role_required = '';
        rule.approvals_required = 1;
      }

      if (rule.condition_type !== 'status_check' && rule.condition_type !== 'previous_status_reached') {
        rule.selected_statuses = [];
      }

      if (rule.condition_type !== 'question_completion') {
        rule.section_scope = 'all';
        rule.question_scope = 'all';
        rule.selected_sections = [];
        rule.selected_sections_for_questions = [];
        rule.selected_questions = [];
      }

      if (rule.condition_type === 'status_check' || rule.condition_type === 'previous_status_reached') {
        rule.required_state = 'reached';
      } else if (rule.condition_type !== 'question_completion') {
        rule.required_state = 'complete';
      }
    },

    on_transition_type_change() {
      if (this.is_automatic_transition_type) {
        this.transition_builder.trigger.action_id = '';
        this.min_approvals_required = 1;
        this.set_transition_condition_mode('advanced');
      }
    },

    on_transition_section_scope_change(rule) {
      this.normalize_transition_condition_rule(rule);
      if (rule.section_scope !== 'specific') {
        rule.selected_sections = [];
      } else {
        rule.selected_sections_for_questions = [];
      }
    },

    on_transition_question_scope_change(rule) {
      this.normalize_transition_condition_rule(rule);
      if (rule.question_scope !== 'specific') {
        rule.selected_sections_for_questions = [];
        rule.selected_questions = [];
      }
    },

    show_transition_required_actions(rule) {
      return String(rule?.condition_type || '') === 'section_action';
    },

    show_transition_question_fields(rule) {
      return String(rule?.condition_type || '') === 'question_completion';
    },

    show_transition_status_check_fields(rule) {
      const condition_type = String(rule?.condition_type || '');
      return condition_type === 'status_check' || condition_type === 'previous_status_reached';
    },

    show_transition_role_field(rule) {
      return String(rule?.condition_type || '') === 'reviewer_approval';
    },

    show_transition_required_approvals_field(rule) {
      return String(rule?.condition_type || '') === 'reviewer_approval';
    },

    show_transition_sections_for_questions(rule) {
      return this.show_transition_question_fields(rule)
        && String(rule?.question_scope || 'all') === 'specific'
        && String(rule?.section_scope || 'all') !== 'specific';
    },

    show_transition_selected_sections(rule) {
      return this.show_transition_question_fields(rule) && String(rule?.section_scope || 'all') === 'specific';
    },

    show_transition_selected_questions(rule) {
      return this.show_transition_question_fields(rule) && String(rule?.question_scope || 'all') === 'specific';
    },

    show_transition_selected_statuses(rule) {
      return this.show_transition_status_check_fields(rule);
    },

    selected_transition_question_options(rule) {
      if (!rule) return [];
      const selected_sections = (
        rule.selected_sections_for_questions?.length
          ? rule.selected_sections_for_questions
          : rule.selected_sections
      ).map(Number);
      const question_scope = String(rule.question_scope || 'all');

      return this.all_form_questions.filter((question) => {
        if (question_scope !== 'specific') return true;
        if (!selected_sections.length) return true;
        return selected_sections.includes(Number(question.section_id));
      });
    },

    selected_transition_section_labels(rule) {
      const selected_section_ids = new Set((rule?.selected_sections || []).map(Number));
      return this.transition_section_options
        .filter((section) => selected_section_ids.has(Number(section.id)))
        .map((section) => section.name);
    },

    selected_transition_question_labels(rule) {
      const selected_question_ids = new Set((rule?.selected_questions || []).map(Number));
      return this.all_form_questions
        .filter((question) => selected_question_ids.has(Number(question.id)))
        .map((question) => question.label);
    },

    selected_transition_status_labels(rule) {
      const selected_status_ids = new Set((rule?.selected_statuses || []).map(Number));
      return this.transition_status_options
        .filter((status) => selected_status_ids.has(Number(status.id)))
        .map((status) => status.name);
    },

    async load_status_reviewers() {
      if (!this.selected_form_id || !this.selected_form_status_assignment_id) {
        this.reset_status_reviewers();
        return;
      }
      this.reviewers_loading = true;
      try {
        const response = await fetch_status_reviewers({
          form_id: Number(this.selected_form_id),
          status_id: Number(this.selected_form_status_assignment_id)
        });
        const data = response?.data || response || {};
        this.status_reviewers = this.normalize_reviewer_payload(data);
        this.reviewer_count_required = Number(this.status_reviewers.required_reviewer_count || 1);
        this.selected_reviewer_user_ids = (this.status_reviewers.users || []).map(u => u.user_id);
        this.selected_reviewer_role_ids = (this.status_reviewers.roles || []).map(r => r.role_id);
        this.sync_approval_rule_inputs();
        if (
          this.selected_section_access_assignment_key
          && !this.section_access_assignment_options.some((option) => option.key === this.selected_section_access_assignment_key)
        ) {
          this.set_selected_section_access_assignment_key('');
        }
      } catch {
        this.reset_status_reviewers();
      } finally {
        this.reviewers_loading = false;
      }
    },

    reset_status_reviewers() {
      this.status_reviewers = null;
      this.reviewer_count_required = 1;
      this.selected_reviewer_user_ids = [];
      this.selected_reviewer_role_ids = [];
      this.approval_rule_order_by_reviewer_user_id = {};
    },

    sync_approval_rule_inputs() {
      const existing_rules = this.status_reviewers?.approval_rules || [];
      const order_map = {};
      existing_rules.forEach(rule => {
        safe_set(order_map, String(rule.workflow_reviewer_id || rule.reviewer_user_id || rule.reviewer_id), rule.reviewer_no);
      });

      this.approval_rule_order_by_reviewer_user_id = this.selected_reviewer_user_records.reduce((acc, reviewer, index) => {
        const reviewer_key = String(reviewer.id);
        safe_set(acc, reviewer_key, safe_get_key(order_map, reviewer_key) || index + 1);
        return acc;
      }, {});
    },

    async save_status_reviewers() {
      if (!this.selected_status_requires_reviewers) {
        this.show_success('No reviewer setup is required for automatic-only transitions on this status.');
        return;
      }
      if (this.reviewer_assign_mode === 'role' && this.selected_reviewer_role_option_id) {
        this.assign_reviewer_role(this.selected_reviewer_role_option_id);
      }
      if (this.reviewer_assign_mode === 'user' && this.selected_reviewer_user_option_id) {
        this.assign_reviewer_user(this.selected_reviewer_user_option_id);
      }
      if (!this.selected_reviewer_user_ids.length && !this.selected_reviewer_role_ids.length) {
        this.show_error('Select at least one reviewer.');
        return;
      }
      this.reviewers_saving = true;
      const loader = await this.show_loader('Saving reviewers...');
      try {
        const form_status_assignment_id = Number(this.selected_form_status_assignment_id || 0);
        if (!form_status_assignment_id) {
          this.show_error('Select a form status before saving reviewers.');
          return;
        }

        const selected_user_ids = new Set(this.selected_reviewer_user_ids.map(Number));
        const selected_role_ids = new Set(this.selected_reviewer_role_ids.map(Number));

        await Promise.all([
          ...(this.status_reviewers?.users || [])
            .filter((user) => !selected_user_ids.has(Number(user.user_id || 0)))
            .map((user) => unassign_status_reviewers({
              form_id: Number(this.selected_form_id),
              status_id: form_status_assignment_id,
              user_id: Number(user.user_id),
            })),
          ...(this.status_reviewers?.roles || [])
            .filter((role) => !selected_role_ids.has(Number(role.role_id || 0)))
            .map((role) => unassign_status_reviewers({
              form_id: Number(this.selected_form_id),
              status_id: form_status_assignment_id,
              role_id: Number(role.role_id),
            })),
        ]);

        await assign_status_reviewers({
          form_id: Number(this.selected_form_id),
          status_id: form_status_assignment_id,
          required_reviewer_count: Number(this.reviewer_count_required || 1),
          reviewers: [
            ...Array.from(selected_user_ids).map((id) => ({ user_id: id })),
            ...Array.from(selected_role_ids).map((id) => ({ role_id: id })),
          ]
        });
        await this.load_status_reviewers();
        this.selected_reviewer_role_option_id = '';
        this.selected_reviewer_user_option_id = '';
        this.show_success('Reviewers saved. Next Step: Configure section permissions for assigned reviewers.');
      } catch {
        this.show_error('Failed to save reviewers.');
      } finally {
        await this.close_loader(loader);
        this.reviewers_saving = false;
      }
    },

    async load_section_access() {
      if (!this.selected_form_id || !this.selected_status_id || !this.selected_section_access_assignment) return;
      this.section_access_loading = true;
      try {
        const assignment_id = Number(this.selected_section_access_assignment.assignment_id);
        const reviewer_key = this.selected_section_access_assignment.type === 'user'
          ? 'workflow_reviewer_user_id'
          : 'workflow_reviewer_role_id';
        const response = await fetch_section_access({ [reviewer_key]: assignment_id });
        const entries = response?.data || response || [];
        const next_matrix = {};

        as_array(entries).forEach((entry) => {
          const { section_id, action_id } = section_access_entry_values(entry);
          if (section_id <= 0) return;
          const section_key = String(section_id);
          const current_actions = Array.isArray(next_matrix[section_key]) ? next_matrix[section_key] : [];
          if (!action_id) {
            next_matrix[section_key] = current_actions;
            return;
          }
          if (!current_actions.includes(action_id)) {
            next_matrix[section_key] = [...current_actions, action_id];
          }
        });

        this.section_access_matrix = next_matrix;
        this.section_access_bulk_action_ids = [];
      } catch (error) {
        this.error('Load section access error:', error);
      } finally {
        this.section_access_loading = false;
      }
    },

   async save_section_access() {
      if (!this.can_manage_section_access) return;

      this.section_access_saving = true;

      const loader = await this.show_loader('Saving permissions...');

      const assignment_id = Number(
        this.selected_section_access_assignment.assignment_id
      );

      const payload = {};

      if (this.selected_section_access_assignment.type === 'user') {
        payload.workflow_reviewer_user_id = assignment_id;
      } else {
        payload.workflow_reviewer_role_id = assignment_id;
      }

      const section_actions = object_entries(this.section_access_matrix).reduce(
        (acc, [section_id, action_ids]) => {
          const normalized = (Array.isArray(action_ids) ? action_ids : [])
            .map(Number)
            .filter(Boolean);

          if (normalized.length) {
            safe_set(acc, String(section_id), normalized);
          }

          return acc;
        },
        {}
      );

      unassign_section_access(payload)
        .then(() => {
          if (object_entries(section_actions).length) {
            return assign_section_access({
              ...payload,
              section_actions,
            });
          }

          return Promise.resolve();
        })
        .then(() => this.load_section_access())
        .then(() => {
          this.show_success('Permissions saved.');
        })
        .catch(() => {
          this.show_error('Failed to save permissions.');
        })
        .finally(async () => {
          await this.close_loader(loader);
          this.section_access_saving = false;
        });
    },

    toggle_section_action_access({ formSectionId, actionId }) {
      const section_id = String(formSectionId);
      const normalized_action_id = Number(actionId);
      if (!is_safe_object_key(section_id)) return;
      const current = safe_keyed_array(this.section_access_matrix, section_id);
      const next_actions = current.includes(normalized_action_id)
        ? current.filter((id) => id !== normalized_action_id)
        : [...current, normalized_action_id];

      this.section_access_matrix = {
        ...this.section_access_matrix,
        [section_id]: next_actions,
      };
    },

    toggle_bulk_action_access(actionId) {
      const normalized_action_id = String(actionId);
      if (this.section_access_bulk_action_ids.includes(normalized_action_id)) {
        this.section_access_bulk_action_ids = this.section_access_bulk_action_ids.filter((id) => id !== normalized_action_id);
      } else {
        this.section_access_bulk_action_ids = [...this.section_access_bulk_action_ids, normalized_action_id];
      }
    },

    apply_bulk_section_access() {
      const normalized_action_ids = this.section_access_bulk_action_ids.map(Number).filter(Boolean);
      const next_matrix = { ...this.section_access_matrix };

      this.section_access_matrix_rows.forEach((row) => {
        next_matrix[String(row.formSectionId)] = [...normalized_action_ids];
      });

      this.section_access_matrix = next_matrix;
      this.section_access_bulk_action_ids = [];
    },

    clear_section_access() {
      this.section_access_matrix = {};
      this.section_access_bulk_action_ids = [];
    },

    async save_transition_rule() {
      if (!this.transition_builder_is_valid) {
        this.show_error(this.transition_builder_validation_message || 'Complete the transition details before saving.');
        return;
      }
      const loader = await this.show_loader('Saving transition...');
      this.transitions_saving = true;
      try {
        if (this.editing_transition_id) {
          const payload = this.build_transition_update_payload(this.editing_transition_id);
          await update_transition_rule(payload);
        } else {
          const payload = this.build_transition_create_payload();
          await create_workflow_status_transition_rule(payload);
        }
        this.transition_builder.conditions.rules = this.transition_condition_rules.map(collapsed_condition_rule);
        await this.load_transition_rules();
        this.transition_mode = 'list';
        this.show_success(`Transition saved. ${this.transition_save_guidance_message}`);
      } catch (error) {
        this.error('Save transition rule error:', error?.response?.data || error);
        const backend_message = this.extract_transition_error_message(error?.response?.data);
        this.show_error(
          typeof backend_message === 'string'
            ? backend_message
            : 'Failed to save transition.'
        );
      } finally {
        await this.close_loader(loader);
        this.transitions_saving = false;
      }
    },

    build_transition_condition_rules() {
      const transition_builder = this.transition_builder || {};
      const conditions = transition_builder.conditions || {};
      return as_array(conditions?.rules).map((rule) =>
        transition_condition_payload_rule(rule, this.resolve_transition_condition_action(rule))
      );
    },

    build_transition_condition_payload() {
      const transition_builder = this.transition_builder || {};
      const conditions = transition_builder.conditions || {};
      const rules = as_array(conditions?.rules);
      const payload_rules = this.build_transition_condition_rules();
      const connectors = rules.slice(0, Math.max(rules.length - 1, 0)).map((rule) =>
        String(rule?.connector_operator || conditions.operator || 'AND')
      );
      const unique_connectors = [...new Set(connectors)];

      if (conditions.mode === 'advanced' && payload_rules.length > 1 && unique_connectors.length > 1) {
        const nested_rule = payload_rules.slice(1).reduce((left, rule, index) => ({
          operator: connectors[index] || 'AND',
          rules: [left, rule],
        }), payload_rules[0]);

        return {
          operator: nested_rule.operator || 'AND',
          rules: nested_rule.rules || [],
        };
      }

      return {
        operator: conditions.mode === 'advanced' ? String(connectors[0] || conditions.operator || 'AND') : 'AND',
        rules: conditions.mode === 'advanced' ? payload_rules : []
      };
    },

    extract_transition_error_message(response_data) {
      if (!response_data) {
        return '';
      }

      const nested_errors = response_data?.errors;
      if (Array.isArray(nested_errors)) {
        return nested_errors.filter(Boolean).join(', ');
      }

      if (nested_errors && typeof nested_errors === 'object') {
        const flattened_errors = flatten_error_strings(nested_errors);
        if (flattened_errors.length) {
          return flattened_errors[0];
        }
      }

      return response_data?.details || response_data?.message || '';
    },

    build_transition_create_payload() {
      const transition_builder = this.transition_builder || {};
      const movement = transition_builder.movement || {};
      const trigger = transition_builder.trigger || {};
      const source_status = this.transition_form_statuses.find(
        (item) => String(item.assignedFormStatusId) === String(movement.from_status_id)
      );
      const target_status = this.transition_form_statuses.find(
        (item) => String(item.assignedFormStatusId) === String(movement.to_status_id)
      );
      const transition_type = this.transition_types.find(
        (item) => String(item.id) === String(trigger.transition_type_id)
      );
      const trigger_action = this.workflow_actions.find(
        (item) => String(item.id) === String(trigger.action_id)
      );

      return {
        form_id: Number(movement.form_id),
        transition_rules: [
          {
            form_status: source_status?.name || '',
            from_status_id: Number(movement.from_status_id),
            to_status: target_status?.name || '',
            to_status_id: Number(movement.to_status_id),
            transition_type: transition_type?.name || '',
            transition_type_id: Number(trigger.transition_type_id),
            action: this.resolve_transition_action_name(trigger_action, transition_type),
            min_approvals_required: Number(this.min_approvals_required || 1),
            is_active: normalize_boolean_flag(movement.is_active, false),
            condition: this.build_transition_condition_payload(),
          }
        ]
      };
    },

    build_transition_update_payload(rule_id) {
      const transition_builder = this.transition_builder || {};
      const movement = transition_builder.movement || {};
      const trigger = transition_builder.trigger || {};
      const transition_type = this.transition_types.find(
        (item) => String(item.id) === String(trigger.transition_type_id)
      );
      const trigger_action = this.workflow_actions.find(
        (item) => String(item.id) === String(trigger.action_id)
      );

      return {
        rule_id: Number(rule_id),
        form_id: Number(movement.form_id),
        from_status_id: Number(movement.from_status_id),
        to_status_id: Number(movement.to_status_id),
        transition_type_id: Number(trigger.transition_type_id),
        action: this.resolve_transition_action_name(trigger_action, transition_type),
        min_approvals_required: Number(this.min_approvals_required || 1),
        is_active: normalize_boolean_flag(movement.is_active, false),
        condition: {
          ...this.build_transition_condition_payload()
        }
      };
    },

    resolve_transition_action_name(trigger_action, transition_type) {
      const explicit_action = String(trigger_action?.name || '').trim();
      if (explicit_action) {
        return explicit_action;
      }

      const normalized_transition_type = String(
        transition_type?.name || this.selected_transition_type?.name || ''
      ).toLowerCase();

      if (normalized_transition_type === 'automatic') {
        return 'Automatic Transition';
      }

      if (normalized_transition_type === 'manual') {
        return 'Manual Transition';
      }

      return 'Workflow Transition';
    },

    resolve_transition_condition_action(rule) {
      return transition_condition_action_label(rule, this.workflow_actions);
    },

    async remove_transition_rule(rule) {
      const id = rule.id || rule.ruleId;
      this.show_confirm('Delete Transition?', 'Remove this transition?', async () => {
        const loader = await this.show_loader('Deleting...');
        try {
          await delete_transition_rule({ form_id: Number(this.selected_form_id), rule_id: Number(id) });
          await this.load_transition_rules();
          this.show_success('Transition deleted.');
        } catch {
          this.show_error('Failed to delete.');
        } finally {
          await this.close_loader(loader);
        }
      });
    },

    init_new_transition() {
      const selected_form_status_id = this.selected_form_transition_status
        ? String(this.selected_form_transition_status.assignedFormStatusId)
        : '';
      this.editing_transition_id = null;
      this.transition_builder = {
        movement: { form_id: String(this.selected_form_id), from_status_id: selected_form_status_id, to_status_id: '', is_active: false },
        trigger: { action_id: '', transition_type_id: '' },
        conditions: {
          mode: 'none',
          operator: 'AND',
          rules: [this.create_empty_transition_condition_rule()],
        }
      };
      this.transition_builder_step = 1;
      this.transition_mode = 'editor';
    },

    edit_transition_rule(rule) {
      this.editing_transition_id = rule.id;
      const full = rule.fullRule || {};
      const resolved_from_status_id = String(
        full.from_status_id || full.from_status?.id || rule.sourceId || ''
      );
      const resolved_to_status_id = String(
        full.to_status_id || full.to_status?.id || rule.targetId || ''
      );
      const resolved_transition_type_id = String(
        full.transition_type_id || full.transition_type?.id || rule.transitionTypeId || ''
      );
      const resolved_action_id = String(
        full.transition_trigger_id ||
        this.workflow_actions.find((item) => String(item.name || '').trim() === String(full.action || rule.action || '').trim())?.id ||
        ''
      );
      const condition = full.condition || {};
      const condition_rules = this.flatten_transition_condition_rules(condition);
      const rules = condition_rules.length
        ? condition_rules.map((item, index) =>
          ({
            ...editable_condition_rule(item, index, this.workflow_actions, resolved_action_id),
            connector_operator: String(item.connector_operator || condition.operator || 'AND'),
          })
        )
        : [this.create_empty_transition_condition_rule()];

      this.transition_builder = {
        movement: {
          form_id: String(this.selected_form_id),
          from_status_id: resolved_from_status_id,
          to_status_id: resolved_to_status_id,
          is_active: normalize_boolean_flag(full.is_active ?? rule.isActive, false),
        },
        trigger: {
          action_id: resolved_action_id || String(rules[0]?.action_id || ''),
          transition_type_id: resolved_transition_type_id,
        },
        conditions: {
          mode: rules.length ? 'advanced' : 'none',
          operator: String(condition.operator || 'AND'),
          rules,
        },
      };
      if (this.is_automatic_transition_type) {
        this.set_transition_condition_mode('advanced');
      }
      this.min_approvals_required = Number(full.min_approvals || rule.minApprovals || 1);
      this.transition_builder_step = 1;
      this.transition_mode = 'editor';
    },

    async load_workflow_actions() {
      this.actions_loading = true;
      try {
        const response = await fetch_all_actions();
        this.workflow_actions = (response?.data || []).map(item => ({
          id: item.id,
          name: item.action_name || item.name || `Action ${item.id}`,
          description: item.description || ''
        }));
      } catch (error) {
        this.error('Load actions error:', error);
      } finally {
        this.actions_loading = false;
      }
    },

    async load_form_sections() {
      if (!this.selected_form_id) return;
      try {
        const items = await fetch_main_sections_by_form(Number(this.selected_form_id));
        this.form_sections = (Array.isArray(items) ? items : [])
          .map((item, index) => this.normalize_transition_main_section(item, index));
      } catch (error) {
        this.error('Load form sections error:', error);
        try {
          const fallback_items = await fetch_form_structure(Number(this.selected_form_id));
          this.form_sections = (Array.isArray(fallback_items) ? fallback_items : [])
            .map((item, index) => this.normalize_transition_main_section(item, index));
        } catch (fallback_error) {
          this.error('Load form sections fallback error:', fallback_error);
          this.form_sections = [];
        }
      }
    },

    async load_section_access_dependencies() {
      if (!this.selected_form_id) return;
      await Promise.all([this.load_form_sections(), this.load_workflow_actions()]);
    },

    async trace_config_request(label, request) {
      try {
        return await request();
      } catch (error) {
        this.error(`[ConfigureWorkflow] ${label} failed`, {
          workflow_id: this.workflow_id,
          route_project_id: this.route_project_id,
          selected_form_id: this.selected_form_id,
          error,
          response_status: error?.response?.status,
          response_data: error?.response?.data,
        });
        throw error;
      }
    },

    async load_workflow_configuration() {
      this.statuses_loading = true;
      try {
        const [workflowResponse, workflowForms, transitionTypes, reviewerRoles] = await Promise.all([
          this.workflow_id
            ? this.trace_config_request(
              'fetch_selected_workflow',
              () => fetch_selected_workflow({ entity_workflow_id: this.workflow_id })
            )
            : Promise.resolve({ data: {} }),
          this.workflow_id
            ? this.trace_config_request(
              'fetch_entity_type_workflow_forms',
              () => fetch_entity_type_workflow_forms(this.build_workflow_form_payload(this.workflow_id))
            )
            : Promise.resolve([]),
          this.trace_config_request('fetch_transition_types', () => fetch_transition_types()),
          this.trace_config_request(
            'fetch_user_roles',
            () => fetch_user_roles(this.route_project_id ? { project_id: Number(this.route_project_id) } : {})
          )
        ]);

        const workflow_payload = workflowResponse?.data || workflowResponse || {};
        const workflow_data = workflow_payload?.workflow_data || [];
        const workflow_available_statuses = workflow_payload?.available_statuses || [];

        this.assigned_status_configs = normalize_assigned_statuses(workflow_data);
        this.workflow_forms = (workflowForms || []).map((f, i) => this.normalize_workflow_form(f, i)).filter(f => f.isAssigned);
        this.transition_types = (transitionTypes?.data || []).map(t => this.normalize_transition_type(t));
        this.reviewer_role_options = (reviewerRoles?.data || reviewerRoles || []).map(r => this.normalize_reviewer_role(r));

        this.initialize_form_selection();
        await this.load_status_library_data(workflow_available_statuses);
        await this.load_available_forms();
        this.initialize_status_selections();
        this.sync_active_tab();
      } catch (error) {
        this.error('[ConfigureWorkflow] load_workflow_configuration failed', {
          workflow_id: this.workflow_id,
          route_project_id: this.route_project_id,
          error,
        });
        this.show_error('Failed to load configuration.');
      } finally {
        this.statuses_loading = false;
      }
    },

    async load_available_forms() {
      this.available_forms_loading = true;
      try {
        const forms = await fetch_entity_type_workflow_forms(this.build_workflow_form_payload(this.workflow_id));
        this.available_forms = (forms || []).map((f, i) => this.normalize_workflow_form(f, i));
      } catch (error) {
        this.available_forms = [];
      } finally {
        this.available_forms_loading = false;
      }
    },

    initialize_form_selection() {
      if (this.workflow_forms.length && !this.selected_form_id) {
        this.selected_form_id = String(this.workflow_forms[0].id);
      }
    },

      initialize_status_selections() {
        const [first, second] = this.transition_form_statuses;
        this.selected_source = first?.name || '';
        this.selected_target = (second || first)?.name || '';

        const available_status_ids = new Set(
          this.transition_form_statuses.map((status) => String(status.workflowStatusId))
        );

        if (!available_status_ids.size) {
          this.selected_status_id = '';
          this.selected_context_transition_id = '';
          return;
        }

        if (!available_status_ids.has(String(this.selected_status_id))) {
          this.selected_status_id = String(first?.workflowStatusId || '');
        }

        const selected_transition_exists = (this.transitions || []).some(
          (transition) => String(transition.id) === String(this.selected_context_transition_id)
        );
        if (!selected_transition_exists) {
          this.selected_context_transition_id = '';
        }
      },

    sync_active_tab() {
      const requested_tab = String(this.$route?.query?.tab || '').trim();
      if (!this.initial_route_tab_applied && requested_tab && this.workflow_tabs.some((tab) => tab.id === requested_tab)) {
        this.active_workflow_tab = requested_tab;
        this.initial_route_tab_applied = true;
        return;
      }

      this.initial_route_tab_applied = true;

      const current_tab = this.workflow_tabs.find((tab) => tab.id === this.active_workflow_tab);
      if (current_tab?.enabled) {
        return;
      }

      if (this.transitions.length) {
        this.active_workflow_tab = 'transitions';
      } else {
        this.active_workflow_tab = this.workflow_forms.length ? 'forms' : 'statuses';
      }
    },

    handle_assign_status_dropdown_outside_click(event) {
      if (this.assign_status_dropdown_open && !this.$el.contains(event.target)) {
        this.close_assign_status_dropdown();
      }
      if (this.active_transition_multiselect_key && !this.$el.contains(event.target)) {
        this.active_transition_multiselect_key = '';
      }
    },

    close_assign_status_dropdown() {
      this.assign_status_dropdown_open = false;
      this.assignable_status_query = '';
    },

    toggle_assign_status_dropdown() {
      this.assign_status_dropdown_open = !this.assign_status_dropdown_open;
    },

    transition_multiselect_open(rule, field) {
      return this.active_transition_multiselect_key === `${rule?.id || 'rule'}:${field}`;
    },

    toggle_transition_multiselect(rule, field) {
      const key = `${rule?.id || 'rule'}:${field}`;
      this.active_transition_multiselect_key = this.active_transition_multiselect_key === key ? '' : key;
    },

    close_transition_multiselect() {
      this.active_transition_multiselect_key = '';
    },

    transition_multiselect_summary(options = [], selected_values = [], fallback = 'Select options') {
      const normalized = Array.isArray(selected_values) ? selected_values.map(String) : [];
      if (!normalized.length) return fallback;
      const labels = options
        .filter((option) => normalized.includes(String(option.id)))
        .map((option) => option.name || option.label || option.action_name || `Option ${option.id}`);
      if (!labels.length) return fallback;
      if (labels.length <= 2) return labels.join(', ');
      return `${labels.slice(0, 2).join(', ')} +${labels.length - 2}`;
    },

    transition_multiselect_option_checked(values = [], option_id) {
      return Array.isArray(values) && values.map(String).includes(String(option_id));
    },

    toggle_transition_multiselect_value(rule, field, option_id) {
      this.normalize_transition_condition_rule(rule);
      const field_key = String(field);
      if (!is_safe_object_key(field_key)) return;
      const next_values = safe_keyed_array(rule, field_key).map(String);
      const normalized_option_id = String(option_id);
      const existing_index = next_values.indexOf(normalized_option_id);

      if (existing_index >= 0) {
        next_values.splice(existing_index, 1);
      } else {
        next_values.push(normalized_option_id);
      }

      safe_set(rule, field_key, next_values);

      if (field === 'selected_sections_for_questions') {
        const valid_question_ids = new Set(this.selected_transition_question_options(rule).map((question) => String(question.id)));
        rule.selected_questions = (rule.selected_questions || []).filter((question_id) => valid_question_ids.has(String(question_id)));
      }
    },

    assignable_status_selected(status_id) {
      return this.selected_assignable_status_ids.includes(String(status_id));
    },

    is_status_assigned_to_workflow(status_id) {
      return this.workflow_assigned_status_ids.has(String(status_id));
    },

    toggle_assignable_status(status_id) {
      const id = String(status_id);
      if (this.is_status_assigned_to_workflow(id)) {
        return;
      }

      if (this.assignable_status_selected(id)) {
        this.selected_assignable_status_ids = this.selected_assignable_status_ids.filter(s => s !== id);
      } else {
        this.selected_assignable_status_ids = [...this.selected_assignable_status_ids, id];
      }
    },

    clear_assignable_status_selection() {
      this.selected_assignable_status_ids = [];
    },

    async assign_selected_workflow_statuses() {
      const statuses_to_assign = this.selected_assignable_statuses;
      if (!statuses_to_assign.length) return;

      const used_orders = this.assigned_statuses
        .map((status) => Number(status.order || 0))
        .filter((order) => order > 0)
        .sort((left, right) => left - right);

      let next_order = used_orders.length ? used_orders[used_orders.length - 1] + 1 : 1;

      this.statuses_saving = true;
      try {
        let next_form_status_ids = [...this.selected_form_status_ids];
        const assigned_configs_to_add = statuses_to_assign.map((status) => ({
          id: Number(`9${Date.now()}${status.id}`),
          status_id: Number(status.id),
          order: next_order++,
          transition_action: String(status.name || '').trim() || 'Submit',
        }));

        await assign_entity_type_workflow_status({
          workflows: assigned_configs_to_add.map((status) => ({
            status_id: Number(status.status_id),
            order: Number(status.order),
            workflow_id: Number(this.workflow_id),
            transition_action: String(status.transition_action || '').trim() || 'Submit',
          }))
        });

        this.assigned_status_configs = [
          ...this.assigned_status_configs,
          ...assigned_configs_to_add,
        ];

        if (this.selected_form_id) {
          const existing_form_status_ids = status_id_set(this.assigned_form_statuses);
          next_form_status_ids = new_form_status_ids(
            this.selected_form_status_ids,
            statuses_to_assign,
            existing_form_status_ids
          );

          this.selected_form_status_ids = next_form_status_ids;
        }

        if (this.selected_form_id && next_form_status_ids.length) {
          this.selected_form_status_ids = next_form_status_ids;
          await this.save_form_statuses({ silent: true });
          this.show_success('Statuses assigned to workflow and selected form.');
        } else {
          this.show_success('Statuses assigned.');
        }

        this.close_assign_status_dropdown();
        this.selected_assignable_status_ids = [];
      } catch (error) {
        this.error('assign_selected_workflow_statuses error', error, error?.response?.data);
        this.show_error(
          error?.response?.data?.message
          || error?.response?.data?.errors
          || 'Failed to assign statuses.'
        );
      } finally {
        this.statuses_saving = false;
      }
    },

    async perform_workflow_status_removal(status, silent = false) {
      this.statuses_saving = true;
      try {
        await unassign_entity_type_workflow_status({
          workflow_id: Number(this.workflow_id),
          status_id: Number(status.id)
        });

        this.selected_form_status_ids = this.selected_form_status_ids.filter(
          (id) => String(id) !== String(status.id)
        );
        this.assigned_form_statuses = this.assigned_form_statuses.filter(
          (assignedStatus) => String(assignedStatus.status_id) !== String(status.id)
        );
        this.assigned_status_configs = this.assigned_status_configs.filter(
          (assignment) => String(assignment.status_id) !== String(status.id)
        );
        this.selected_assignable_status_ids = this.selected_assignable_status_ids.filter(
          (id) => String(id) !== String(status.id)
        );

        if (!silent) {
          this.show_success('Status removed.');
        }
      } catch (error) {
        this.error('remove_workflow_status error', error, error?.response?.data);
        this.show_error(error?.response?.data?.message || 'Failed to remove.');
      } finally {
        this.statuses_saving = false;
      }
    },

    async remove_workflow_status(status, options = {}) {
      const safe_options = options || {};
      const skipConfirm = Boolean(safe_options.skipConfirm);
      const silent = Boolean(safe_options.silent);
      if (skipConfirm) {
        await this.perform_workflow_status_removal(status, silent);
        return;
      }

      const removal_callback = this.perform_workflow_status_removal.bind(this, status, silent);
      this.show_confirm('Remove Status?', 'Are you sure?', removal_callback);
    },

    async toggle_workflow_form_assignment(form) {
      const formId = Number(form?.id || form?.form_id || 0);
      if (!formId) return;

      const loading_key = String(formId);
      this.form_toggle_loading_by_form_id = as_object(this.form_toggle_loading_by_form_id);
      safe_set(this.form_toggle_loading_by_form_id, loading_key, true);

      const wasAssigned = Boolean(form.isAssigned);
      form.isAssigned = !wasAssigned;

      const loader = await this.show_loader(wasAssigned ? 'Unassigning...' : 'Assigning...');
      try {
        const payload = {
          workflow_id: Number(this.workflow_id),
          entity_workflow_id: Number(this.workflow_id),
          entity_type_workflow_id: Number(this.workflow_id),
          form_id: formId,
          form_company_id: formId,
        };
        if (this.route_project_id) payload.project_id = Number(this.route_project_id);

        if (wasAssigned) {
          if (!form.assignmentId) {
            throw new Error('Missing workflow form assignment id.');
          }
          await unassign_entity_type_workflow_form({
            entity_workflow_form_id: Number(form.assignmentId || 0),
          });
        } else {
          await assign_entity_type_workflow_form(payload);
        }
        await this.load_workflow_configuration();
        this.show_success('Form assignment updated.');
      } catch (error) {
        form.isAssigned = wasAssigned;
        this.error('toggle_workflow_form_assignment error', error, error?.response?.data);
        this.show_error(error?.response?.data?.message || 'Failed to update form assignment.');
      } finally {
        this.form_toggle_loading_by_form_id = as_object(this.form_toggle_loading_by_form_id);
        safe_set(this.form_toggle_loading_by_form_id, loading_key, false);
        await this.close_loader(loader);
      }
    },

    clear_transition_context() {
      this.selected_context_transition_id = '';
    },

    set_active_workflow_tab(tabId, options = {}) {
      const target_tab = this.workflow_tabs.find((tab) => tab.id === tabId);
      if (target_tab && !target_tab.enabled) {
        return;
      }

      if (!options.preserveTransitionContext) {
        this.clear_transition_context();
      }
      this.active_workflow_tab = tabId;
    },

    redirect_from_disabled_workflow_tab() {
      const active_tab = this.workflow_tabs.find((tab) => tab.id === this.active_workflow_tab);
      if (!active_tab || active_tab.enabled) {
        return;
      }

      this.clear_transition_context();
      this.active_workflow_tab = this.workflow_tabs.find((tab) => tab.id === 'transitions')?.enabled
        ? 'transitions'
        : 'statuses';
    },

    set_transition_mode(mode) {
      this.transition_mode = mode;
    },

    set_transition_builder_step(step) {
      this.transition_builder_step = step;
    },

    select_status(statusId) {
      this.selected_status_id = String(statusId);
    },

    async openConfigureForm(form) {
      try {
        this.transitions_loading = true;
        this.selected_form_id = String(form?.id || form?.form_id || '');
        // switch to statuses tab and initialize selections for that form
        this.active_workflow_tab = 'statuses';
        this.initialize_status_selections();
        // load statuses and any transitions for the selected form
        await this.load_form_statuses_and_transitions();
      } catch (e) {
        this.error('openConfigureForm error', e);
      }
    },

    openConfigureRules(status) {
      try {
        this.select_status(status.id || status.status_id || '');
        this.set_active_workflow_tab('transitions');
        // load transitions for selected form/status if form selected
        this.load_transition_rules();
        this.init_new_transition();
      } catch (e) {
        this.error('openConfigureRules error', e);
      }
    },

    async openConfigureTransitionReviewers(transition) {
      try {
        this.select_transition_context(transition);
        this.set_active_workflow_tab('reviewers', { preserveTransitionContext: true });
        await this.load_status_reviewers();
      } catch (e) {
        this.error('openConfigureTransitionReviewers error', e);
      }
    },

    async openConfigureReviewerSectionAccess(reviewer) {
      try {
        this.set_active_workflow_tab('section_access', { preserveTransitionContext: true });
        await this.load_status_reviewers();
        const key = reviewer?.key
          || (reviewer?.reviewerType === 'user' ? `user:${reviewer.userId || reviewer.id}` : `role:${reviewer.roleId || reviewer.id}`);
        if (key) {
          this.set_selected_section_access_assignment_key(key);
        } else {
          this.select_first_section_access_assignment();
        }
        await this.load_section_access_dependencies();
      } catch (e) {
        this.error('openConfigureReviewerSectionAccess error', e);
      }
    },

    toggleUseForForm(status) {
      try {
        // Toggle a local flag for UI purposes; persist logic can be added later
        if (this.$set) {
          this.$set(status, 'useForForm', !status.useForForm);
        } else {
          status.useForForm = !status.useForForm;
        }
      } catch {
        // Vue 3 doesn't have $set; mutate directly
        status.useForForm = !status.useForForm;
      }
    },

    toggleKeepInPool(status) {
      try {
        if (this.$set) {
          this.$set(status, 'keepInPool', !status.keepInPool);
        } else {
          status.keepInPool = !status.keepInPool;
        }
      } catch {
        status.keepInPool = !status.keepInPool;
      }
    },

    form_status_selected(statusId) {
      return this.selected_form_status_ids.includes(String(statusId));
    },

    form_status_has_transition_rules(statusId) {
      const assignment = this.form_status_assignment_for_status(statusId);
      const assigned_form_status_id = Number(assignment?.id || 0);
      if (!assigned_form_status_id) {
        return false;
      }

      return (this.transitions || []).some((transition) =>
        Number(transition.sourceId || 0) === assigned_form_status_id
        || Number(transition.targetId || 0) === assigned_form_status_id
      );
    },

    async toggle_form_status_selection(statusId) {
      if (!this.selected_form_id || this.statuses_saving) {
        if (!this.selected_form_id) {
          this.show_error('Select a workflow form first.');
        }
        return;
      }

      if (this.form_status_has_transition_rules(statusId)) {
        this.show_error('Remove transition rules before changing this status assignment.');
        return;
      }

      const normalized_id = String(statusId);
      const previous_ids = [...this.selected_form_status_ids];
      if (this.form_status_selected(normalized_id)) {
        this.selected_form_status_ids = this.selected_form_status_ids.filter((id) => id !== normalized_id);
      } else {
        this.selected_form_status_ids = [...this.selected_form_status_ids, normalized_id];
      }

      try {
        this.statuses_saving = true;
        await this.save_form_statuses({ silent: true });
      } catch (error) {
        this.selected_form_status_ids = previous_ids;
      } finally {
        this.statuses_saving = false;
      }
    },

    async remove_form_status_selection(statusId) {
      if (!this.selected_form_id || this.statuses_saving) {
        if (!this.selected_form_id) {
          this.show_error('Select a workflow form first.');
        }
        return;
      }

      if (this.form_status_has_transition_rules(statusId)) {
        this.show_error('Remove transition rules before changing this status assignment.');
        return;
      }

      const normalized_id = String(statusId);
      const previous_ids = [...this.selected_form_status_ids];
      this.selected_form_status_ids = this.selected_form_status_ids.filter((id) => id !== normalized_id);

      try {
        this.statuses_saving = true;
        await this.save_form_statuses({ silent: true });
      } catch (error) {
        this.selected_form_status_ids = previous_ids;
      } finally {
        this.statuses_saving = false;
      }
    },

    async handle_keep_in_pool_change(status, event) {
      const checked = Boolean(event?.target?.checked);
      if (checked) {
        return;
      }

      if (this.form_status_has_transition_rules(status?.id)) {
        if (event?.target) {
          event.target.checked = true;
        }
        this.show_error('Remove transition rules before removing this status from the workflow pool.');
        return;
      }

      await this.remove_workflow_status(status, {
        skipConfirm: true,
        silent: true,
      });
    },

   start_form_status_drag(statusId, event = null) {
    this.dragged_form_status_id = String(statusId);

    if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData(
            "text/plain",
            this.dragged_form_status_id
        );
    }
  },

    form_status_assignment_for_status(status_id) {
      return (this.assigned_form_statuses || []).find(
        (status) => String(status.status_id) === String(status_id)
      ) || null;
    },

    form_status_is_initial(status_id) {
      return Boolean(this.form_status_assignment_for_status(status_id)?.is_initial);
    },

    form_status_is_final(status_id) {
      return Boolean(this.form_status_assignment_for_status(status_id)?.is_final);
    },

    update_form_status_flag_locally(status_id, flags = {}) {
      const normalized_id = String(status_id);
      this.assigned_form_statuses = (this.assigned_form_statuses || []).map((status) => {
        if (String(status.status_id) !== normalized_id) {
          return flags.is_initial === true
            ? { ...status, is_initial: false }
            : status;
        }

        return {
          ...status,
          ...(Object.prototype.hasOwnProperty.call(flags, 'is_initial') ? { is_initial: Boolean(flags.is_initial) } : {}),
          ...(Object.prototype.hasOwnProperty.call(flags, 'is_final') ? { is_final: Boolean(flags.is_final) } : {}),
        };
      });
    },

    async set_form_status_initial(status_id) {
      if (!this.form_status_selected(status_id) || this.statuses_saving) return;
      const assignment = this.form_status_assignment_for_status(status_id);
      if (assignment?.is_final && this.selected_form_status_ids.length > 1) {
        this.show_warning(
          'Initial and Final Status',
          'Initial and Final can only be on the same status when the workflow has one status.'
        );
      }

      const previous_statuses = this.assigned_form_statuses.map((status) => ({ ...status }));

      this.update_form_status_flag_locally(status_id, { is_initial: true });
      try {
        this.statuses_saving = true;
        await this.save_form_statuses({ silent: true });
      } catch (error) {
        this.assigned_form_statuses = previous_statuses;
      } finally {
        this.statuses_saving = false;
      }
    },

    async toggle_form_status_final(status_id) {
      if (!this.form_status_selected(status_id) || this.statuses_saving) return;
      const assignment = this.form_status_assignment_for_status(status_id);
      const next_final = !assignment?.is_final;
      const selected_count = this.selected_form_status_ids.length;

      if (next_final && assignment?.is_initial && selected_count > 1) {
        this.show_warning(
          'Initial and Final Status',
          'Initial and Final can only be on the same status when the workflow has one status.'
        );
        return;
      }

      const previous_statuses = this.assigned_form_statuses.map((status) => ({ ...status }));
      this.update_form_status_flag_locally(status_id, { is_final: next_final });
      try {
        this.statuses_saving = true;
        await this.save_form_statuses({ silent: true });
      } catch (error) {
        this.assigned_form_statuses = previous_statuses;
      } finally {
        this.statuses_saving = false;
      }
    },
    

    allow_form_status_drop(event) {
    if (event) {
      event.preventDefault(); 
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = "move";
      }
    }
  },
  

    async reorder_form_statuses(targetStatusId) {
      const dragged_id = String(this.dragged_form_status_id || '');
      const target_id = String(targetStatusId || '');
      if (!dragged_id || !target_id || dragged_id === target_id) {
        return;
      }

      const current_ids = [...this.selected_form_status_ids];
      const previous_ids = [...this.selected_form_status_ids];
      const from_index = current_ids.indexOf(dragged_id);
      const to_index = current_ids.indexOf(target_id);

      if (from_index === -1 || to_index === -1) {
        return;
      }

      current_ids.splice(from_index, 1);
      current_ids.splice(to_index, 0, dragged_id);
      this.selected_form_status_ids = current_ids;
      const displayed_ids = this.displayed_assigned_statuses.map((status) => String(status.id));
      const previous_configs = this.assigned_status_configs.map((assignment) => ({ ...assignment }));
      this.apply_workflow_status_order_locally(displayed_ids);

      try {
        this.statuses_saving = true;
        await assign_entity_type_workflow_status({
          workflows: this.build_workflow_status_order_payload(displayed_ids),
        });
        await this.save_form_statuses({ silent: true });
      } catch {
        this.selected_form_status_ids = previous_ids;
        this.assigned_status_configs = previous_configs;
      } finally {
        this.statuses_saving = false;
      }
    },

    end_form_status_drag() {
      this.dragged_form_status_id = '';
    },

    async save_form_statuses(options = {}) {
      const safe_options = options || {};
      const silent = Boolean(safe_options.silent);
      if (!this.selected_form_id) {
        this.show_error('Select a workflow form first.');
        throw new Error('Select a workflow form first.');
      }

      const ordered_selected = (this.selected_form_status_ids || [])
        .filter((status_id, index, ids) => ids.findIndex((id) => String(id) === String(status_id)) === index)
        .map((status_id) => this.assigned_statuses.find((status) => String(status.id) === String(status_id)))
        .filter(Boolean);
      const selected_status_ids = new Set(ordered_selected.map((status) => String(status.id)));
      const removed_statuses = this.assigned_form_statuses.filter(
        (status) => !selected_status_ids.has(String(status.status_id))
      );

      try {
        if (removed_statuses.length) {
          await Promise.all(removed_statuses.map((status) => unassign_form_status({
            form_id: Number(this.selected_form_id),
            status_id: Number(status.status_id),
            workflow_id: Number(this.workflow_id),
          })));
        }
        

        let assign_response = null;
        if (ordered_selected.length) {
          const current_flags_by_status_id = new Map(
            this.assigned_form_statuses.map((status) => [String(status.status_id), status])
          );
          let initial_status_id = ordered_selected.find(
            (status) => current_flags_by_status_id.get(String(status.id))?.is_initial
          )?.id;
          if (!initial_status_id) {
            initial_status_id = ordered_selected[0]?.id;
          }

          assign_response = await assign_form_status({
            form_statuses: ordered_selected.map((status, index) => ({
              workflow_id: Number(this.workflow_id),
              form_id: Number(this.selected_form_id),
              status_id: Number(status.id),
              order: index + 1,
              is_initial: String(status.id) === String(initial_status_id),
              is_final: Boolean(current_flags_by_status_id.get(String(status.id))?.is_final),
            })),
          });
        }

        this.apply_form_status_selection_locally(ordered_selected, assign_response);
        if (!silent) {
          this.show_success('Form statuses saved.');
        }
      } catch (error) {
        this.error('save_form_statuses error', error, error?.response?.data);
        const message = String(error?.response?.data?.message || '');
        if (message.toLowerCase().includes('cannot unassign')) {
          this.selected_form_status_ids = Array.from(new Set([
            ...this.selected_form_status_ids,
            ...removed_statuses.map((status) => String(status.status_id)).filter(Boolean),
          ]));

          if (!silent) {
            this.show_error('This status has related setup. Use the transition, reviewer, and section access tabs to edit or remove that setup, then update the form statuses.');
          }
        } else {
          this.show_error(message || 'Failed to save form statuses.');
        }
        throw error;
      }
    },

    go_to_manage_status() {
      this.$router.push({ name: 'ManageStatus' });
    },

   async assign_selected_workflow_form() {
  if (!this.selected_assignable_form_ids.length) return;

  const loader = await this.show_loader('Assigning forms...');

  try {
    const assignerId = this.$store?.getters?.currentUserId || null;

    for (const formId of this.selected_assignable_form_ids) {
      const payload = {
        workflow_id: Number(this.workflow_id),
        entity_workflow_id: Number(this.workflow_id),
        entity_type_workflow_id: Number(this.workflow_id),
        form_id: Number(formId),
        form_company_id: Number(formId),
      };

      if (assignerId) {
        payload.assigner_id = Number(assignerId);
      }

      if (this.route_project_id) {
        payload.project_id = Number(this.route_project_id);
      }

      await assign_entity_type_workflow_form(payload);
    }

    await this.load_workflow_configuration();

    this.selected_assignable_form_ids = [];

    this.show_success('Forms assigned successfully.');
  } catch (error) {
    this.error(
      'Assign form error:',
      error,
      error?.response?.data || error?.message
    );

    const serverMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message;

    this.show_error(serverMessage || 'Failed to assign forms.');
  } finally {
    await this.close_loader(loader);
  }
},
handle_assign_status_dropdown_outside_click(event) {
  const dropdown = this.$refs.assignFormMultiselect;

  if (
    this.assign_form_dropdown_open &&
    dropdown &&
    !dropdown.contains(event.target)
  ) {
    this.assign_form_dropdown_open = false;
  }

  if (
    this.active_transition_multiselect_key &&
    !this.$el.contains(event.target)
  ) {
    this.active_transition_multiselect_key = '';
  }
},

    handle_section_access_reviewer_change(key) {
      if (key.startsWith('user:')) {
        this.selected_section_access_user_key = key;
        this.selected_section_access_role_key = '';
      } else {
        this.selected_section_access_role_key = key;
        this.selected_section_access_user_key = '';
      }
    },

    is_form_toggle_loading(formId) {
      return Boolean(safe_get_key(this.form_toggle_loading_by_form_id, String(formId)));
    },

    async load_role_users(roleId = null) {
      const selected_role_id = String(roleId || this.selected_reviewer_user_role_filter_id || '');
      this.selected_reviewer_user_role_filter_id = selected_role_id;
      this.selected_reviewer_user_option_id = '';
      if (!selected_role_id) {
        this.available_users = [];
        return;
      }
      this.role_users_loading = true;
      try {
        const response = await fetch_users_by_role({
          role_id: Number(selected_role_id),
          ...(this.route_project_id ? { project_id: Number(this.route_project_id) } : {}),
        });
        const users = response?.data || response || [];
        this.available_users = Array.isArray(users)
          ? users.map((user) => ({
            id: Number(user.id || user.user_id || 0),
            name: String(user.name || user.full_name || user.user_name || 'User').trim(),
            email: String(user.email || '').trim(),
          })).filter((user) => user.id > 0)
          : [];
      } catch (error) {
        this.available_users = [];
        this.show_error('Failed to load users for the selected role.');
      } finally {
        this.role_users_loading = false;
      }
    },

    async load_users_for_role() {
      this.selected_reviewer_user_role_filter_id = String(this.reviewer_role_query || '');
      await this.load_role_users();
    },

    toggle_reviewer_user(userId) {
      const normalized_id = Number(userId);
      if (this.selected_reviewer_user_ids.includes(normalized_id)) {
        this.remove_reviewer_user(normalized_id);
      } else {
        this.assign_reviewer_user(normalized_id);
      }
    },

    toggle_reviewer_role(roleId) {
      const normalized_id = Number(roleId);
      if (!normalized_id) return;
      if (this.selected_reviewer_role_ids.map(Number).includes(normalized_id)) {
        this.remove_reviewer_role(normalized_id);
        return;
      }
      this.assign_reviewer_role(normalized_id);
    },

    toggle_all_reviewer_roles() {
      const all_role_ids = (this.reviewer_role_options || [])
        .map((role) => Number(role.id || 0))
        .filter((role_id) => role_id > 0);
      const selected_role_ids = new Set((this.selected_reviewer_role_ids || []).map(Number));
      const all_selected = all_role_ids.length > 0
        && all_role_ids.every((role_id) => selected_role_ids.has(role_id));

      if (all_selected) {
        this.selected_reviewer_role_ids = (this.selected_reviewer_role_ids || [])
          .filter((role_id) => !all_role_ids.includes(Number(role_id)));
        return;
      }

      this.selected_reviewer_role_ids = Array.from(new Set([
        ...(this.selected_reviewer_role_ids || []).map(Number),
        ...all_role_ids,
      ]));
    },

    toggle_all_reviewer_users(userIds = null) {
      const source_user_ids = Array.isArray(userIds) && userIds.length
        ? userIds
        : (this.reviewer_user_options || this.available_users || []);
      const all_user_ids = source_user_ids
        .map((user) => (typeof user === 'object' ? Number(user.id || 0) : Number(user)))
        .filter((user_id) => user_id > 0);
      const selected_user_ids = new Set((this.selected_reviewer_user_ids || []).map(Number));
      const all_selected = all_user_ids.length > 0
        && all_user_ids.every((user_id) => selected_user_ids.has(user_id));

      if (all_selected) {
        this.selected_reviewer_user_ids = (this.selected_reviewer_user_ids || [])
          .filter((user_id) => !all_user_ids.includes(Number(user_id)));
        return;
      }

      this.selected_reviewer_user_ids = Array.from(new Set([
        ...(this.selected_reviewer_user_ids || []).map(Number),
        ...all_user_ids,
      ]));
    },

    remove_assigned_reviewer_role(roleId) {
      this.remove_reviewer_role(roleId);
    },

    remove_assigned_reviewer_user(userId) {
      this.remove_reviewer_user(userId);
    },

    selected_reviewer_role_label(roleId) {
      const role = this.reviewer_role_options.find((item) => Number(item.id) === Number(roleId));
      return role?.name || `Role ${roleId}`;
    },

    selected_reviewer_user_label(userId) {
      const user = this.available_users.find((item) => Number(item.id) === Number(userId))
        || (this.status_reviewers?.users || []).find((item) => Number(item.user_id || item.id) === Number(userId));
      return user?.name || `User ${userId}`;
    },

    add_reviewer() {
      if (this.reviewer_assign_mode === 'role') {
        this.assign_reviewer_role(this.selected_reviewer_role_option_id);
        this.selected_reviewer_role_option_id = '';
        return;
      }

      this.assign_reviewer_user(this.selected_reviewer_user_option_id);
      this.selected_reviewer_user_option_id = '';
    },

    remove_assigned_reviewer(reviewer) {
      if (reviewer?.reviewerType === 'role') {
        this.remove_reviewer_role(reviewer.roleId);
        return;
      }
      this.remove_reviewer_user(reviewer.userId);
    },

    edit_assigned_reviewer(reviewer) {
      if (reviewer?.reviewerType === 'role') {
        this.reviewer_assign_mode = 'role';
        this.selected_reviewer_role_option_id = String(reviewer.roleId || '');
        return;
      }

      this.reviewer_assign_mode = 'user';
      this.selected_reviewer_user_option_id = String(reviewer.userId || '');
    },

    set_selected_section_access_assignment_key(key) {
      if (!key) {
        this.selected_section_access_role_key = '';
        this.selected_section_access_user_key = '';
        this.section_access_matrix = {};
        return;
      }

      if (String(key).startsWith('user:')) {
        this.selected_section_access_user_key = String(key);
        this.selected_section_access_role_key = '';
      } else {
        this.selected_section_access_role_key = String(key);
        this.selected_section_access_user_key = '';
      }
    },

    update_approval_order({ workflowReviewerId, order }) {
      const next_order_map = as_object(this.approval_rule_order_by_reviewer_user_id);
      safe_set(next_order_map, String(workflowReviewerId), Math.max(1, Number(order || 1)));
      this.approval_rule_order_by_reviewer_user_id = next_order_map;
    },

    reviewer_type_id_for_rule(reviewer) {
      const existing_rule = (this.status_reviewers?.approval_rules || []).find(
        (rule) => Number(rule.reviewer_user_id || rule.reviewer_id || 0) === Number(reviewer.userId || reviewer.id)
      );
      if (existing_rule?.reviewer_type) {
        return Number(existing_rule.reviewer_type);
      }
      return 2;
    },

    async save_approval_rules() {
      if (!this.status_reviewers?.id || !this.reviewer_user_assignments.length) {
        this.show_error('Assign reviewer users before saving approval order.');
        return;
      }

      this.approval_rules_saving = true;
      const loader = await this.show_loader('Saving approval order...');
      try {
        const existing_rules = Array.isArray(this.status_reviewers?.approval_rules) ? this.status_reviewers.approval_rules : [];

        await Promise.all(
          existing_rules
            .filter((rule) => Number(rule.id || 0) > 0)
            .map((rule) => delete_workflow_status_approval_rule({ approval_rule_id: Number(rule.id) }))
        );

        const create_rules = this.reviewer_user_assignments.map((reviewer) => ({
            reviewer_type: this.reviewer_type_id_for_rule(reviewer),
            reviewer_id: Number(reviewer.userId),
            reviewer_number: Math.max(
              1,
              Number(safe_get_key(this.approval_rule_order_by_reviewer_user_id, String(reviewer.workflowReviewerId)) || reviewer.order || 1)
            ),
          }));

        if (create_rules.length) {
          await create_workflow_status_approval_rule({
            rules: {
              form_workflow_id: Number(this.status_reviewers.id),
              rules: create_rules,
            },
          });
        }

        await this.load_status_reviewers();
        this.show_success('Approval order saved.');
      } catch (error) {
        this.show_error('Failed to save approval order.');
      } finally {
        await this.close_loader(loader);
        this.approval_rules_saving = false;
      }
    },

    reset_action_form() {
      this.action_form = {
        action_id: null,
        action_name: '',
        description: '',
      };
      this.duplicate_action_warning = '';
    },

    reset_action_edit_form() {
      this.action_edit_form = {
        action_id: null,
        action_name: '',
        description: '',
      };
      this.duplicate_action_warning = '';
    },

    edit_action(action) {
      this.action_edit_form = {
        action_id: Number(action?.id || 0) || null,
        action_name: String(action?.name || '').trim(),
        description: String(action?.description || '').trim(),
      };
      this.duplicate_action_warning = '';
    },

    save_action_record() {
      return this.save_action();
    },

    edit_action_record(actionId) {
      const action = this.workflow_actions.find((item) => Number(item.id) === Number(actionId));
      if (action) {
        this.edit_action(action);
        const modal = new window.bootstrap.Modal(document.getElementById('workflow_action_edit_modal'));
        modal.show();
      }
    },

    remove_action_record(actionId) {
      return this.delete_action(actionId);
    },

    save_action_edit_record() {
      return this.save_action(true);
    },

    assign_reviewer_user(userId) {
      const id = Number(userId);
      if (!this.selected_reviewer_user_ids.includes(id)) {
        this.selected_reviewer_user_ids.push(id);
      }
    },

    remove_reviewer_user(userId) {
      const id = Number(userId);
      this.selected_reviewer_user_ids = this.selected_reviewer_user_ids.filter(i => i !== id);
    },

    assign_reviewer_role(roleId) {
      const id = Number(roleId);
      if (id > 0 && !this.selected_reviewer_role_ids.map(Number).includes(id)) {
        this.selected_reviewer_role_ids.push(id);
      }
    },

    remove_reviewer_role(roleId) {
      const id = Number(roleId);
      this.selected_reviewer_role_ids = this.selected_reviewer_role_ids.filter(i => i !== id);
    },

    async save_action(is_edit = false) {
      const form = is_edit ? this.action_edit_form : this.action_form;
      const action_name = String(form.action_name || '').trim();
      const description = String(form.description || '').trim();

      if (!action_name) {
        this.show_error('Action name is required.');
        return;
      }

      const duplicate = this.workflow_actions.find((action) =>
        String(action.name || '').trim().toLowerCase() === action_name.toLowerCase()
        && Number(action.id) !== Number(form.action_id || 0)
      );
      if (duplicate) {
        this.duplicate_action_warning = 'An action with this name already exists.';
        return;
      }

      this.action_saving = true;
      const loader = await this.show_loader('Saving action...');
      try {
        this.duplicate_action_warning = '';
        if (form.action_id) {
          await update_action({
            action_id: Number(form.action_id),
            action_name,
            description,
          });
        } else {
          await create_action({
            action_name,
            description,
          });
        }
        await this.load_workflow_actions();
        if (is_edit) {
          const modal = window.bootstrap.Modal.getInstance(document.getElementById('workflow_action_edit_modal'));
          if (modal) modal.hide();
          this.reset_action_edit_form();
        } else {
          this.reset_action_form();
        }
        this.show_success('Action saved.');
      } catch (error) {
        this.show_error('Failed to save action.');
      } finally {
        await this.close_loader(loader);
        this.action_saving = false;
      }
    },
    selected_forms_count() {
      return Array.isArray(this.selected_form_ids) ? this.selected_form_ids.length : 0;
    },
    selected_rules_count() {
      return Array.isArray(this.selected_rule_ids) ? this.selected_rule_ids.length : 0;
    },
    selected_forms_label() {
      if (!this.bindable_forms.length) return 'No forms available';
      if (!this.selected_forms_count) return 'Select form(s) to bind';
      return `${this.selected_forms_count} form${this.selected_forms_count === 1 ? '' : 's'} selected`;
    },
      fetch_available_forms() {
      const result = axios
        .get(
          GET_FORMS_URL,
          get_request_config({
            params: this.project_id ? { project_id: this.project_id } : {}
          })
        )
        .then((response) => {
          const responseData = this.parse_response_data(response.data);
          const rawForms = responseData.data || responseData || [];

          this.available_forms = (Array.isArray(rawForms) ? rawForms : [])
            .map((form) => ({
              id: form.id || form_id,
              form_name: form.name || form.name || `Form ${form.id || form.form_id}`
            }))
            .filter((form) => form.id);

          const output = this.available_forms;
          return output;
        })
        .catch(() => {
          this.available_forms = [];
          const output = this.available_forms;
          return output;
        });

      return result;
    },

    async delete_action(actionId) {
      this.show_confirm('Delete Action?', 'Are you sure?', async () => {
        this.action_delete_running_id = actionId;
        const loader = await this.show_loader('Deleting action...');
        try {
          await delete_action({ action_id: Number(actionId) });
          await this.load_workflow_actions();
          if (Number(this.action_form.action_id) === Number(actionId)) {
            this.reset_action_form();
          }
          this.show_success('Action deleted.');
        } catch (error) {
          this.show_error('Failed to delete action.');
        } finally {
          await this.close_loader(loader);
          this.action_delete_running_id = null;
        }
      });
    }
  }
};

